import React, { useCallback } from "react";
import moment from "moment";
import { ListGroup } from "react-bootstrap";
import { useHistory } from "react-router-dom";

import { Button } from "components";
import { hasPermissions, permissionList, getFullName } from "helpers";
import { PendType } from "types";

import styles from "../pend.module.scss";

type PendDetailsRowProps = {
	pend: PendType;
	urlPendPage: string;
};

const PendDetailsRow = ({ pend, urlPendPage }: PendDetailsRowProps) => {
	const history = useHistory();

	const createdOnDay = moment
		.utc(pend?.createdOn)
		.local()
		.format("DD MMMM YYYY");
	const createdOnTime = moment.utc(pend?.createdOn).local().format("h:mm a");
	const guest = pend?.role?.value === 3;
	const guestCannotResponse =
		guest && !hasPermissions(permissionList.ViewInProgressApplication);
	const closedPend = pend?.status?.value === 4;

	const buttonText =
		guestCannotResponse || closedPend ? "History" : "Pend Update";

	const redirectPendPage = useCallback(() => {
		history.push(`${urlPendPage}/pend/${pend?.id}`);
	}, [urlPendPage, pend.id, history]);

	return (
		<ListGroup.Item className="d-flex justify-content-between align-items-center">
			<div>
				<ul className={styles.dateList}>
					<li>{createdOnDay}</li>
					<li>{createdOnTime}</li>
					<li>
						Pended by&nbsp;
						{getFullName(pend?.createdBy)}
					</li>
				</ul>
				<div>Pend - {pend?.number} Details</div>
				<dl className={styles.descriptionList}>
					<dd className="text-muted">Status</dd>
					<dt>{pend?.status?.displayName}</dt>
				</dl>
				<dl className={styles.descriptionList}>
					<dd className="text-muted">Reason</dd>
					<dt>
						{pend?.reasons
							?.map(reason => {
								return reason?.name;
							})
							.join(", ")}
					</dt>
				</dl>
				<div className="text-muted break-word">{pend?.details}</div>
			</div>
			<div>
				<Button
					value={buttonText}
					variant="secondary"
					onClick={redirectPendPage}
				/>
			</div>
		</ListGroup.Item>
	);
};

export default PendDetailsRow;
